import { language as lan_inactivePartnerTip } from "./inactive-partner-tip";
import { language as lan_storeProdutFilter } from "./store-product-filter";
import { language as lan_storeProdutList } from "./store-product-list";
import { language as lan_emptyStoreTip } from "./empty-store-tip";
import { language as lan_emptyStoreProducTip } from "./empty-store-product-tip";

let language = {
    // parther为激活提示
    ...lan_inactivePartnerTip,
    // 店铺产品过滤条件
    ...lan_storeProdutFilter,
    // 店铺产品列表
    ...lan_storeProdutList,
    // 空店铺提示
    ...lan_emptyStoreTip,
    // 空店铺产品提示
    ...lan_emptyStoreProducTip,
    // 禁止添加店铺产品提示Unsupported product
    STORE_PRODUCT_UNSUPPORTED_PRODUCT_TIP_TITLE: "Unsupported product",
    STORE_PRODUCT_UNSUPPORTED_PRODUCT_TIP_DES: "Opps, the store does not support the addition of store products.",
    // 店铺产品更新成功-询问用户是否需要不同步店铺产品
    STORE_PRODUCT_UPDATE_SUCCEED_TIP_TITLE: "Update store product Successfully",
    STORE_PRODUCT_UPDATE_SUCCEED_TIP_DES: "You have successfully updated your store product. Next, you can sync this product to your online e-shop. Click [Sync] to sync it now or click [Later] to sync it later.",
    // 店铺产品同步提示
    STORE_PRODUCT_SYNCHRONIZED_TITLE:"Store products have been synchronized",
    STORE_PRODUCT_SYNCHRONIZED_CONTENT:"Discover Select Select synced store products. Do you need to filter synced store products?",
    // 店铺不属于partner 
    STORE_PRODUCT_MISMATCH_STORE_TITLE:"Store Mismatch Partner",
    STORE_PRODUCT_MISMATCH_STORE_CONTENT:"The current store seems like does Not Belong to Current Partner.",




};

export { language }